import React, { useState, useRef, useEffect } from 'react';

import { FAQItem } from './FAQItem';

import './ContactLensFAQs.scss';

const FAQS = [
  {
    question: 'How do I find my prescription?',
    answer: `You can check your latest prescriptions here. Alternatively, you could schedule a free consultation with one of our optometrists.`,
    link: {
      text: 'Book your free consultation',
      url: '/stores/sg',
    },
  },
  {
    question: 'How long can I wear these colour lenses?',
    answer: `Clear Vision lenses offer 12-16 hours of comfortable wear. However, individual performance may vary depending on eye conditions, environmental factors, and frequency of use.`,
  },
  {
    question: 'Where are colour lenses manufactured from?',
    answer: `They are manufactured in Korea`,
  },
  {
    question: 'Do we offer trial colour lenses?',
    answer: `Currently, we do not offer trial lenses for our colour contacts`,
  },
];

export const ContactLensFAQs = () => {
  const [expandedItems, setExpandedItems] = useState({});
  const contentRefs = useRef([]);

  const toggleExpand = index => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  if (contentRefs.current.length !== FAQS.length) {
    contentRefs.current = Array(FAQS.length)
      .fill()
      .map((_, i) => contentRefs.current[i] || React.createRef());
  }

  useEffect(() => {
    contentRefs.current = FAQS.map((_, i) => contentRefs.current[i] ?? React.createRef());
  }, []);

  return (
    <div className="contact-lens-faqs">
      <div className="contact-lens-faqs__container">
        <h3 className="contact-lens-faqs__title">FAQs</h3>

        {FAQS.map((faq, index) => {
          const isExpanded = !!expandedItems[index];

          return (
            <FAQItem
              key={index}
              contentRef={contentRefs.current[index]}
              faq={faq}
              index={index}
              isExpanded={isExpanded}
              toggleExpand={toggleExpand}
            />
          );
        })}
      </div>
    </div>
  );
};
